(function () {
	'use strict';
	angular.module('app',
			[
				// Angular modules 
				'ngRoute',
				'ngSanitize'

				// Custom modules 

				// 3rd Party Modules

			])
		.config([
			'$httpProvider', '$locationProvider',
			function ($httpProvider, $locationProvider) {
				$httpProvider.defaults.withCredentials = true;
				$locationProvider.html5Mode({ enabled: true, requireBase: false, rewriteLinks: false });
			}
		]);

})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/modules/_app.js
// module id = 5
// module chunks = 0